import { useEffect, useState } from "react";
import classNames from "classnames";
import { Image, Radio, Space, TextArea, Typography } from "@payping/web-components";

import { buildUrl } from "@payping/utilities-shared/url";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { URLS } from "@payping/utilities-shared/consts";
import styles from "../styles.module.scss";
import { Size, Theme } from "./data";

const NamadPayping = () => {
  const { t } = useAppTranslation();
  const [size, setSize] = useState<string>("lg");
  const [theme, setTheme] = useState<string>("light");
  const [width, setWidth] = useState<string>();
  const [height, setHeight] = useState<string>();
  const [logoSrc, setLogoSrc] = useState<string>();

  useEffect(() => {
    switch (size) {
      case "lg":
        setWidth("144px");
        setHeight("173px");
        break;
      case "sm":
        setWidth("64px");
        setHeight("77px");
        break;
      default:
        setWidth("96px");
        setHeight("115px");
        break;
    }

    switch (theme) {
      case "light":
        setLogoSrc(buildUrl(URLS.STORAGE_URL, "logo/white.png").toString());
        break;
      case "dark":
      default:
        setLogoSrc(buildUrl(URLS.STORAGE_URL, "logo/blue.png").toString());
        break;
    }
  }, [size, theme]);

  const script = `<span id="PPTrust" >
    <script src="${buildUrl(URLS.STORAGE_URL, "trust-v3.js").toString()}"
        theme="${theme}"
        size="${size}" ></script>
</span>`;

  return (
    <Space direction={"vertical"} className="tw-w-full" size={32}>
      <Space direction={"vertical"} className="tw-w-full">
        <Typography.Text>{t("services.detail.trust.ui")}</Typography.Text>
        <div className={classNames(styles.trustContainer, styles.dark)}>
          <Image width={width} height={height} src={logoSrc} />
        </div>
        <Typography.Text>
          {t("services.detail.trust.detail")}: {width?.replace("px", "")}x{height?.replace("px", "")}{" "}
          {t("services.detail.trust.pixels")}, {t(`theme.${theme}`)}
        </Typography.Text>
      </Space>
      <Space direction={"vertical"} className="tw-w-full" size={24}>
        <Space direction={"vertical"}>
          <Typography.Text>{t("size.choose")}</Typography.Text>
          <Radio.Group value={size} onChange={(e) => setSize(e.target.value)}>
            {Object.values(Size).map((s) => (
              <Radio.Button key={s.value} value={s.value}>
                {t(`size.${s.value}`)}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Space>
        <Space direction={"vertical"}>
          <Typography.Text>{t("theme.choose")}</Typography.Text>
          <Radio.Group value={theme} onChange={(e) => setTheme(e.target.value)}>
            {Object.keys(Theme).map((key) => (
              <Radio.Button key={key} value={key}>
                {t(`theme.${key}`)}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Space>
        <Space direction={"vertical"} className="tw-w-full">
          <div className="tw-flex tw-justify-between">
            {t("script")}
            <Typography.Text copyable={{ text: script }}></Typography.Text>
          </div>
          <TextArea className="en-font ltr" rows={6} value={script} />
        </Space>
      </Space>
    </Space>
  );
};

export default NamadPayping;
